import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function NavTabs() {
    const location = useLocation();
    const currentPath = location.pathname;

    const tabs = [
        { name: '회사소개', path: '/company', position: 'left' },
        { name: '회사연혁', path: '/history', position: 'center' },
        { name: '특허/인증/수상', path: '/certifications', position: 'right' },
    ];

    const getTabStyle = (path, position) => {
        const isActive = currentPath === path;
        const baseStyle = "px-6 py-3 text-sm md:text-base font-medium transition-colors duration-200";
        const roundedStyle = position === 'left' ? 'rounded-tl-md' : position === 'right' ? 'rounded-tr-md' : '';

        // Fix: Ensure text is visible on white background (active) and white on dark background (inactive)
        // Active: White background, Blue text
        // Inactive: Transparent background (white text), Hover white background (blue text)
        const activeStyle = isActive
            ? "bg-white text-blue-800"
            : "text-white hover:bg-white hover:text-blue-800";

        return `${baseStyle} ${roundedStyle} ${activeStyle}`;
    };

    return (
        <div className="absolute bottom-0 w-full bg-black bg-opacity-40 flex justify-center">
            <div className="flex">
                {tabs.map((tab) => (
                    <Link
                        key={tab.path}
                        to={tab.path}
                        className={getTabStyle(tab.path, tab.position)}
                    >
                        {tab.name}
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default NavTabs;
